// src/styles/components/MuiPaper.js
const MuiPaper = {
  styleOverrides: {
    root: ({ theme }) => ({
      transition: theme.transitions.create(['box-shadow', 'border-color']),
    }),
    elevation1: {
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
    },
    elevation8: {
      boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)',
    },
  },
  variants: [
    {
      props: { variant: 'outlined' },
      style: {
        borderWidth: '1px',
      },
    },
  ],
};

export default MuiPaper;